import { render } from "./ConfettiBombAnimation.vue?vue&type=template&id=731ebad9&ts=true"
import script from "./ConfettiBombAnimation.vue?vue&type=script&lang=ts"
export * from "./ConfettiBombAnimation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__